import { getStorageValue, setStorageValue } from '@helpers/storage';
import { StorageValues } from '@interfaces/storage';

import { TutorialId } from '../interfaces';

/**
 * Reads the set of tutorials the user has fully completed, persisted in
 * localStorage so progress survives reloads.
 */
export const getCompletedTutorials = (): TutorialId[] => {
  return getStorageValue<TutorialId[]>(StorageValues.CompletedTutorials) ?? [];
};

/**
 * Marks a tutorial as completed and persists the updated set.
 *
 * @param id - Tutorial that just finished playing through to its last step.
 * @returns The updated set of completed tutorial ids.
 */
export const markTutorialCompleted = (id: TutorialId): TutorialId[] => {
  const completed = getCompletedTutorials();

  if (completed.includes(id)) {
    return completed;
  }

  const updated = [...completed, id];
  setStorageValue(StorageValues.CompletedTutorials, updated);

  return updated;
};
